import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { Container, Row } from 'reactstrap'
import BtnWhite from '../../../Shared/Buttons/BtnWhite';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { resetState, goToPage, setServiceToDisconnect, setDisconnectTypeOfService } from '../DisconnectServiceSlice'
import images from '../DisconnectPhotos/images'
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../utilities/analytics/tracking';
import { isBrowser, isMobile } from "react-device-detect";
import './IsSuccessfullCallbackPage'
import { clearStateHistoryAction } from '../../../../utilities/stateHistory/stateHistorySlice';

function IsSuccessfullCallbackPage(props) {

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        reportAllGAOptionOnEnterPage();
    }, [])


    function reportAllGAOptionOnEnterPage() {
        if(props.CallbackIsSuccess && props.serviceToDisconnect.canDisconnectOnline === false) {
            gaEvent(gaParams.DISCONNECT_ENTER_SUCCESS_CALLBACK_PAGE.category, gaParams.DISCONNECT_ENTER_SUCCESS_CALLBACK_PAGE.eventType, gaParams.DISCONNECT_ENTER_SUCCESS_CALLBACK_PAGE.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.canDisconnectOnline === false) {
            gaEvent(gaParams.DISCONNECT_ENTER_UNSUCCESSFUL_CALLBACK_PAGE.category, gaParams.DISCONNECT_ENTER_UNSUCCESSFUL_CALLBACK_PAGE.eventType, gaParams.DISCONNECT_ENTER_UNSUCCESSFUL_CALLBACK_PAGE.eventParams)
        }
        if(props.CallbackIsSuccess && props.serviceToDisconnect.BusinessTypeCanBeDisconnected === false) {
            gaEvent(gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_PAGE.category, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_PAGE.eventType, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_PAGE.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.BusinessTypeCanBeDisconnected === false) {
            gaEvent(gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_ENTER_UNSUCCESS_CALLBACK.category, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_ENTER_UNSUCCESS_CALLBACK.eventType, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_ENTER_UNSUCCESS_CALLBACK.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.ServiceType != "" && props.serviceToDisconnect.ServiceType != "Cellular") {
            gaEvent(gaParams.DISCONNECT_ENTER_FAILED_TO_CALLBACK_PAGE.category, gaParams.DISCONNECT_ENTER_FAILED_TO_CALLBACK_PAGE.eventType, props.serviceToDisconnect.serviceType)
        }
        if(props.hadCallback !== null && props.hadCallback === true && props.serviceToDisconnect.serviceType != "" && props.serviceToDisconnect.serviceType != "Cellular") {
            gaEvent(gaParams.DISCONNECT_ENTER_WE_GLAD_YOU_GAVE_SECOND_CHANCE_PAGE.category, gaParams.DISCONNECT_ENTER_WE_GLAD_YOU_GAVE_SECOND_CHANCE_PAGE.eventType, props.serviceToDisconnect.serviceType)
        }
        if(props.CallbackIsSuccess && props.serviceToDisconnect.BusinessTypeCanBeDisconnected === false) {
            gaEvent(gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_PAGE.category, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_PAGE.eventType, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_PAGE.eventParams)
        }
        if(props.CallbackIsSuccess && props.serviceToDisconnect.serviceType == "Cellular") {
            gaEvent(gaParams.DISCONNECT_ENTER_WE_GLAD_YOU_GAVE_SECOND_CHANCE_PAGE_CELLULAR.category, gaParams.DISCONNECT_ENTER_WE_GLAD_YOU_GAVE_SECOND_CHANCE_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_ENTER_WE_GLAD_YOU_GAVE_SECOND_CHANCE_PAGE_CELLULAR.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.serviceType != "" && props.serviceToDisconnect.serviceType != "Cellular") {
            gaEvent(gaParams.DISCONNECT_ENTER_FAILED_TO_CALLBACK_PAGE.category, gaParams.DISCONNECT_ENTER_FAILED_TO_CALLBACK_PAGE.eventType, props.serviceToDisconnect.serviceType)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.BusinessTypeCanBeDisconnected === false) {
            gaEvent(gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_ENTER_UNSUCCESS_CALLBACK.category, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_ENTER_UNSUCCESS_CALLBACK.eventType, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_ENTER_UNSUCCESS_CALLBACK.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.serviceType == "Cellular" && props.serviceToDisconnect.BusinessTypeCanBeDisconnected === true || !props.CallbackIsSuccess && props.serviceToDisconnect.serviceType == "Cellular" && props.serviceToDisconnect.canDisconnectOnline === true) {
            gaEvent(gaParams.DISCONNECT_ENTER_FAILED_TO_CALLBACK_PAGE_CELLULAR.category, gaParams.DISCONNECT_ENTER_FAILED_TO_CALLBACK_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_ENTER_FAILED_TO_CALLBACK_PAGE_CELLULAR.eventParams)
        }
    }

    function reportAllGAOptionOnClick() {
        if(props.CallbackIsSuccess && props.serviceToDisconnect.canDisconnectOnline === false) {
            gaEvent(gaParams.DISCONNECT_CLICK_FINISH_IN_SUCCESS_CALLBACK_PAGE.category, gaParams.DISCONNECT_CLICK_FINISH_IN_SUCCESS_CALLBACK_PAGE.eventType, gaParams.DISCONNECT_CLICK_FINISH_IN_SUCCESS_CALLBACK_PAGE.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.canDisconnectOnline === false) {
            gaEvent(gaParams.DISCONNECT_CLICK_FINISH_IN_UNSUCCESSFUL_CALLBACK_PAGE.category, gaParams.DISCONNECT_CLICK_FINISH_IN_UNSUCCESSFUL_CALLBACK_PAGE.eventType, gaParams.DISCONNECT_CLICK_FINISH_IN_UNSUCCESSFUL_CALLBACK_PAGE.eventParams)
        }
        if(props.CallbackIsSuccess && props.serviceToDisconnect.BusinessTypeCanBeDisconnected === false) {
            gaEvent(gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_CLICK_ON_FINISH.category, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_CLICK_ON_FINISH.eventType, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_CLICK_ON_FINISH.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.BusinessTypeCanBeDisconnected === false) {
            gaEvent(gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_ON_FINISH_IN_UNSUCCESS_CALLBACK.category, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_ON_FINISH_IN_UNSUCCESS_CALLBACK.eventType, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_ON_FINISH_IN_UNSUCCESS_CALLBACK.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.serviceType != "" && props.serviceToDisconnect.serviceType != "Cellular") {
            gaEvent(gaParams.DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE.category, gaParams.DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE.eventType, props.serviceToDisconnect.serviceType)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.serviceType == "Cellular") {
            gaEvent(gaParams.DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE_CELLULAR.category, gaParams.DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE_CELLULAR.eventParams)
        }
        if(props.hadCallback !== null && props.hadCallback === true && props.serviceToDisconnect.serviceType != "" && props.serviceToDisconnect.serviceType != "Cellular") {
            gaEvent(gaParams.DISCONNECT_CLICK_FINISH_WE_GLAD_YOU_GAVE_SECOND_CHANCE.category, gaParams.DISCONNECT_CLICK_FINISH_WE_GLAD_YOU_GAVE_SECOND_CHANCE.eventType, props.serviceToDisconnect.serviceType)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.serviceType != "" && props.serviceToDisconnect.serviceType != "Cellular") {
            gaEvent(gaParams.DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE.category, gaParams.DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE.eventType, props.serviceToDisconnect.serviceType)
        }
        if(props.CallbackIsSuccess && props.serviceToDisconnect.BusinessTypeCanBeDisconnected === false) {
            gaEvent(gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_CLICK_ON_FINISH.category, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_CLICK_ON_FINISH.eventType, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_SUCCESS_CALLBACK_CLICK_ON_FINISH.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.serviceType == "") {
            gaEvent(gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_ON_FINISH_IN_UNSUCCESS_CALLBACK.category, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_ON_FINISH_IN_UNSUCCESS_CALLBACK.eventType, gaParams.DISCONNECT_PRODUCT_ALREADY_IN_DISCONNECT_PROCESS_CLICK_ON_FINISH_IN_UNSUCCESS_CALLBACK.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.serviceType == "Cellular") {
            gaEvent(gaParams.DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE_CELLULAR.category, gaParams.DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_CLICK_FINISH_IN_FAILED_TO_CALLBACK_PAGE_CELLULAR.eventParams)
        }
        if(props.CallbackIsSuccess && props.serviceToDisconnect.serviceType == "Cellular") {
            gaEvent(gaParams.DISCONNECT_CLICK_FINISH_WE_GLAD_YOU_GAVE_SECOND_CHANCE_CELLULAR.category, gaParams.DISCONNECT_CLICK_FINISH_WE_GLAD_YOU_GAVE_SECOND_CHANCE_CELLULAR.eventType, gaParams.DISCONNECT_CLICK_FINISH_WE_GLAD_YOU_GAVE_SECOND_CHANCE_CELLULAR.eventParams)
        }
        if(!props.CallbackIsSuccess && props.serviceToDisconnect.canDisconnectOnline === false) {
            gaEvent(gaParams.DISCONNECT_CLICK_FINISH_IN_UNSUCCESSFUL_CALLBACK_PAGE.category, gaParams.DISCONNECT_CLICK_FINISH_IN_UNSUCCESSFUL_CALLBACK_PAGE.eventType, gaParams.DISCONNECT_CLICK_FINISH_IN_UNSUCCESSFUL_CALLBACK_PAGE.eventParams)
        }
    }

    async function redirect() {
        reportAllGAOptionOnClick();
        props.clearStateHistoryAction();
        var content = await props.context.loadContentByPath(props.redirectTo);
        props.context.navigateTo(content);
    }

    return (
        <>
        {props.hadCallback !== null && props.hadCallback === true ? 
            <Container className="IsSuccessfullCallbackPage-root">
                <Row className="header-row">
                    <h3 className="header">רק רגע, כבר קבענו לדבר!</h3>
                </Row>
                <Row className="txt-body-row">
                    <p className="txt-body">כנראה שביקשת שנחזור אליך בתהליך אחר, אז נדבר בקרוב</p>
                </Row>
                <Row className="txt-body-row">
                    {isBrowser ? null : <p style={{marginTop: '55px', marginBottom: '0px'}} className="txt-body">רוצה לברר את העניין? אנחנו כאן</p>}
                    {isMobile ? 
                    <a className="white-btn" href={`tel:${window.Config.businessCallNumber}`}>
                    שיחה למוקד השירות 
                        <Image className="img" src={images.phonePurple} />
                    </a> 
                    :
                    <div className="white-btn">
                        כדי להשלים את תהליך הניתוק אפשר לפנות אלינו ל-{window.Config.technicalSupportPhone} ונשמח לעזור
                    </div>
                    }
                </Row>
                <Row className="btn-row text-center">
                    <div onClick={() => redirect()} className="btn-summit"><BtnSubmit text='סיום'/></div>
                </Row>
            </Container> 
            : 
            <Container className="IsSuccessfullCallbackPage-root">
                <Row className="header-row">
                {props.CallbackIsSuccess && <h3 className="header">תודה, נשתמע בקרוב</h3>}
                {!props.CallbackIsSuccess && <h3 className="header">רק רגע, הייתה תקלה ומספר הטלפון לא נשמר</h3>}
                </Row>
                <Row className="img-row">
                {props.CallbackIsSuccess ? <div className="img-main"><Image src={images.likeBtn} /></div> : <div className="img-main"><Image src={images.failedCallback} /></div>}
                </Row>
                <Row className="txt-body-row">
                    {!props.CallbackIsSuccess && <p className="txt-body">כדי להשלים את תהליך הניתוק אפשר לפנות אלינו ל-{window.Config.technicalSupportPhone} ונשמח לעזור</p>}
                </Row>
                <Row className="btn-row text-center">
                    <div onClick={() => redirect()} className="btn-summit"><BtnWhite text={'סיום'}/></div>
                </Row>
            </Container>}
        </>
    )
}

const mapStateToProps = (state) => ({
    stepParams: state.disconnectServicesBlock.stepParams,
    CallbackIsSuccess: state.disconnectServicesBlock.CallbackIsSuccess,
    hadCallback: state.disconnectServicesBlock.callBackAlreadyExist,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
    canUpgradeCellular: state.disconnectServicesBlock.canUpgradeCellular
});

const mapDispatchToProps = {
    goToPage,
    setServiceToDisconnect,
    setDisconnectTypeOfService,
    resetState,
    clearStateHistoryAction
};
  
export default connect(mapStateToProps, mapDispatchToProps)(IsSuccessfullCallbackPage);
